import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Icon, P, FlexRow } from '@contently/toolkit';

export default function DropdownWrapper({ filterState, setFilterState }) {
  const TriggerButton = () => (
    <FlexRow>
      <b>
        <P style={{ fontSize: "12px", lineHeight: "30px"}}>{filterState}</P>
      </b>
      <Icon type="angle-down" />
    </FlexRow>
  );

  const names = ['All comments', 'Resolved comments', 'Open comments'];

  const dropdownActions = names.map((name, i) => ({
    name,
    action: () => setFilterState(dropdownActions[i].name.toString())
  }));

  return <Dropdown links={dropdownActions} Trigger={TriggerButton} />;
}

DropdownWrapper.propTypes = {
  filterState: PropTypes.string.isRequired,
  setFilterState: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/DropdownWrapper.jsx